<template>
  <div class="library">
    <div>
      <ai-breadcrumb />
      <div class="new-button">
        <guide class="guide-button" />
      </div>
    </div>
    <div class="toolbar">
      <el-form class="search-form" :inline="true" size="small">
        <el-form-item class="search-form-gutter" :label="$t('gpt.desc')">
          <el-input v-model="desc" />
        </el-form-item>
        <el-form-item class="search-form-gutter" :label="$t('gpt.when')">
          <el-select style="width: 128px" v-model="currentDate" :placeholder="$t('common.all')" clearable filterable>
            <el-option v-for="item in dateList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="search-form-gutter" :label="$t('gpt.favorite')">
          <el-checkbox v-model="currentFavorite"></el-checkbox>
        </el-form-item>
        <el-form-item class="search-form-gutter">
          <el-button type="primary" icon="el-icon-search" @click="clickSearch">{{ $t("common.search") }}</el-button>
        </el-form-item>
        <el-form-item class="search-form-gutter"><el-button class="excel-dl-btn" icon="el-icon-download"
            :disabled="true">{{ $t("analysis.downloadAll") }}</el-button></el-form-item>
        <el-form-item class="search-form-gutter" :label="$t('gpt.preferUpgrade')">
          <el-switch v-model="preferUpgrade" size="small"></el-switch>
        </el-form-item>
      </el-form>
    </div>
    <div class="data-content">
      <p v-if="loading" class="data-loading">
        <i class="el-icon-loading" />&nbsp;{{ $t("common.loading") }}...
      </p>
      <p v-else-if="!tableData || tableData.length === 0" class="data-loading">
        {{ $t("common.noMoreData") }}
      </p>
      <el-row v-else :gutter="10" style="margin-bottom: -10px">
        <el-col class="data-block" :lg="{ span: '5-24' }" v-for="item in tableData" :key="item.url">
          <div class="data-block-content">
            <el-image class="content-image"
              :src="(preferUpgrade && item.regenImagePath ? item.regenImagePath : item.url) | imageUrl(false)"
              :preview-src-list="[imageUrl(preferUpgrade && item.regenImagePath ? item.regenImagePath : item.url, false)]"
              fit="contain" />
            <div class="data-block-text">
              <el-row class="content-line" style="float: right;">
                <el-button style="float: right" type="primary" size="mini" @click="openAnalysisDrawer(item)">
                  {{ $t('common.detail') }}
                </el-button>
                <el-image v-if="item.regenImagePath"
                  style="width: 40px; float: right; margin-top: -4px; margin-right: 5px;"
                  :src="require('@/assets/premium.png')" fit="contain" />
                <el-image class="hidden-lg-and-down"
                  style="width: 40px; float: right; margin-top: -4px; margin-right: 5px;"
                  :src="require('@/assets/basic.png')" fit="contain" />
              </el-row>
              <el-row class="content-line">
                <el-tag v-if="item.analysisResult" class="score-tag"
                  :type="getScoreType(item.analysisResult.overall_score, 100)" size="small">
                  {{ item.analysisResult.overall_score }} {{ '/ 100' }}
                </el-tag>
              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>
      <pagination v-show="total > 0" :total="total" :offset.sync="listQuery.offset" :limit.sync="listQuery.limit"
        layout="sizes, prev, pager, next, total " @pagination="fetchData" />
      <el-drawer class="analysis-result-drawer" :visible.sync="drawerVisible" :title="$t('gpt.analysisResult')"
        append-to-body size="900px">
        <div class="analysis-result-container">
          <analysis-result :data="currentRow" />
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/display.css';
import { fetchTaskDates, fetchImages } from "@/api/gpt";
import AiBreadcrumb from "@/components/AiBreadcrumb";
import AnalysisResult from "@/views/services/agent-advisor/AnalysisResult";
import Pagination from "@/components/Pagination";
import Guide from "@/components/Guide";
import { imageUrl } from "@/filters";

export default {
  components: {
    AiBreadcrumb,
    Pagination,
    Guide,
    AnalysisResult
  },
  data() {
    return {
      desc: "",
      currentDate: "",
      dateList: [],
      currentFavorite: false,
      tableData: [],
      listQuery: {
        offset: 0,
        limit: 10,
      },
      total: 0,
      loading: false,
      drawerVisible: false,
      currentRow: null,
      preferUpgrade: false,
    };
  },
  methods: {
    initListQuery() {
      this.listQuery = {
        offset: 0,
        limit: 10,
      };
    },
    // 根据分数获取标签类型
    getScoreType(score, fullScore = 100) {
      if (score >= 80 && fullScore == 100 || score >= 8 && fullScore == 10) return 'success';
      if (score >= 60 && fullScore == 100 || score >= 6 && fullScore == 10) return 'warning';
      return 'danger';
    },
    fetchDateList() {
      fetchTaskDates({ category: "advisor" }).then((response) => {
        if (response.success) {
          this.dateList = response.result || [];
        }
      });
    },
    clickSearch() {
      this.initListQuery();
      this.fetchData();
    },
    fetchData() {
      this.loading = true;
      fetchImages({
        category: "advisor",
        desc: this.desc,
        date: this.currentDate,
        favorite: this.currentFavorite,
        ...this.listQuery,
      }).then((response) => {
        this.loading = false;
        if (response.success) {
          this.tableData = response.result.items || [];
          this.total = response.result.totalCount;
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    imageUrl(url, isExternal) {
      return imageUrl(url, isExternal);
    },
    openAnalysisDrawer(row) {
      this.currentRow = row;
      this.drawerVisible = true;
    }
  },
  mounted() {
    this.initListQuery();
    this.fetchDateList();
    this.fetchData();
  },
};
</script>

<style lang="scss" scoped>
.library {
  .el-col-lg-5-24 {
    width: 1/5 * 100%;
  }

  .new-button {
    text-align: right;
    width: 100%;
    margin: 10px 0;
  }

  .toolbar {
    background-color: #fff;
    padding: 10px 10px 0 10px;
    width: 100%;
    margin-bottom: 9.5px;

    .search-form {
      min-height: 32px;
      display: inline-block;

      .search-form-gutter {
        margin-bottom: 10px;
      }

      ::v-deep .el-cascader .el-input__inner {
        height: 32px !important;
      }

      ::v-deep .el-cascader__tags {
        padding-top: 2px;
      }
    }

    .download-btn {
      display: inline-block;
    }
  }

  .data-content {
    overflow: hidden;
    font-size: small;
    margin-bottom: -10px;

    .data-loading {
      text-align: center;
      font-size: 14px;
      color: #606266;
      margin-top: 10px;
      margin-bottom: 20px;
    }

    .data-block {
      margin-bottom: 10px;

      .data-block-content {
        background-color: #fff;
        padding-bottom: 5px;

        .content-image {
          width: 100%;
          height: 0;
          padding-bottom: 100%;

          ::v-deep img {
            position: absolute;
            margin-bottom: 5px;
          }
        }

        .data-block-text {
          margin-top: 5px;
          text-align: left;
          padding: 0 10px 5px;
        }

        .content-line {
          font-weight: bold;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          color: rgba(0, 0, 0, 0.65);

          .score-tag {
            height: 28px;
            line-height: 28px;
          }
        }
      }
    }
  }
}

.analysis-result-drawer {
  ::v-deep .el-drawer__header {
    padding-top: 10px;
    margin-bottom: 10px;
  }

  .analysis-result-container {
    border-top: 1px solid #e8e8e8;
    padding-top: 10px;
    background-color: #f5f7fa;
  }
}
</style>